/* eslint-disable */
import React from "react";
import styled from "styled-components";
import NotFoundImg from "../styles/404.gif";

const Wrapper = styled.div`
  background-color: rgb(154, 216, 239);
`;

const Img = styled.img`
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const NotFound = () => (
  <Wrapper>
    <Img src={NotFoundImg} alt="" />
  </Wrapper>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/Notfound.js